import { useState } from "react";

import {
  Box,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import { useRoleContext } from "hooks";

interface Props {
  cancellationReason: string;
  onCancellationUpdate: (newValue: string) => void;
  loading: boolean;
  error: string | null;
}

export function CancelShipmentBookingModalContent(props: Props) {
  const { loading, cancellationReason, onCancellationUpdate, error } = props;
  const { role } = useRoleContext();
  const [value, setValue] = useState<string | null>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const chosenOption = event.target.value;
    setValue(chosenOption);
    if (chosenOption === "other") {
      onCancellationUpdate("");
    } else {
      onCancellationUpdate(event.target.value);
    }
  };

  if (loading || !role) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }
  return (
    <Stack direction="column" spacing={1}>
      <Typography variant="h5">Why are you cancelling this booking?</Typography>
      <Typography>
        Cancelling the booking will update the shipment status. This action can
        not be reversed.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        The cancellation reason will be shared with the{" "}
        {role.type === "CARRIER" ? "shipper" : "carrier"}.
      </Typography>
      <Box mb="2rem">
        <FormControl>
          <RadioGroup value={value} onChange={handleChange}>
            {role?.type === "SHIPPER" ? (
              <>
                <FormControlLabel
                  value="Customer cancelled the order"
                  control={<Radio />}
                  label="Customer cancelled the order"
                />
                <FormControlLabel
                  value="Shipment Details Changed"
                  control={<Radio />}
                  label="Shipment Details Changed"
                />
                <FormControlLabel
                  value="Truck Unavailable"
                  control={<Radio />}
                  label="Truck Unavailable"
                />
                <FormControlLabel
                  value="other"
                  control={<Radio />}
                  label="Other"
                />
              </>
            ) : (
              <>
                <FormControlLabel
                  value="Truck no longer available"
                  control={<Radio />}
                  label="Truck no longer available"
                />
                <FormControlLabel
                  value="Shipment details changed"
                  control={<Radio />}
                  label="Shipment details changed"
                />
                <FormControlLabel
                  value="Credit not approved"
                  control={<Radio />}
                  label="Credit not approved"
                />
                <FormControlLabel
                  value="Other"
                  control={<Radio />}
                  label="Other"
                />
              </>
            )}
          </RadioGroup>
        </FormControl>
      </Box>
      {value === "other" && (
        <TextField
          id="cancellation-reason"
          variant="outlined"
          onChange={(e) => onCancellationUpdate(e.target.value)}
          value={cancellationReason}
        />
      )}
      {error != null && !loading && (
        <Typography color="red" align="center">
          {error}
        </Typography>
      )}
    </Stack>
  );
}
